import { quickActionsAdapter, catalogAdapter } from "./slice";

import type { RootState } from "../store";

const { selectAll: selectAllQuickActionsUnsorted } =
  quickActionsAdapter.getSelectors(
    (state: RootState) => state.quickActions.quickActions,
  );

export const { selectAll: selectAllCatalog } = catalogAdapter.getSelectors(
  (state: RootState) => state.quickActions.catalog,
);

export const selectAllQuickActions = (state: RootState) => {
  if (!state.quickActions?.quickActions) {
    return [];
  }
  const quickActions = selectAllQuickActionsUnsorted(state);
  return quickActions.sort((a, b) => a.position - b.position);
};

// Keep backward compatibility
export const selectAll = selectAllQuickActions;
